import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeProvider } from '@mui/material/styles'
import Avatar from '@mui/material/Avatar'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Typography from '@mui/material/Typography'
import lightTheme from '../theme'
import Alert from '@mui/material/Alert'

export default function LoginPage(props) {
    const { fetchResource } = props
    const { t } = useTranslation()
    const [showAlert, setShowAlert] = useState(false)
    const [alertMessage, setAlertMessage] = useState('')
    const googleButtonRef = useRef(null)

    useEffect(() => {
        showAlert &&
            setTimeout(() => {
                setShowAlert(false)
            }, 3000)
    }, [showAlert])

    useEffect(() => {
        const gis = window.google?.accounts?.id
        if (!gis) return
        gis.initialize({
            client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            callback: handleGoogleCredential
        })
        gis.renderButton(googleButtonRef.current, { theme: 'outline', size: 'large', width: 280 })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function handleGoogleCredential(response) {
        const loginRequest = await fetchResource({
            resource: 'login/google',
            body: { credential: response.credential },
            blocking: true
        })

        if (loginRequest.error) {
            setAlertMessage(loginRequest.error)
            setShowAlert(true)
            window.scrollTo(0, 0)
        }
    }

    return (
        <ThemeProvider theme={lightTheme}>
            <Grid container direction='column' height='100vh' justifyContent='center' alignContent='center'>
                <Grid item>
                    {showAlert && (
                        <Alert className='alert' severity='error' variant='filled'>
                            {alertMessage}
                        </Alert>
                    )}
                    <Box
                        sx={{
                            marginBottom: 18,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            maxWidth: '315px'
                        }}
                    >
                        <Avatar sx={{ m: 1, bgcolor: 'primary.dark' }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component='h1' variant='h5'>
                            {t('login.title')}
                        </Typography>
                        <Box ref={googleButtonRef} sx={{ mt: 3 }} />
                    </Box>
                </Grid>
            </Grid>
        </ThemeProvider>
    )
}
